import { type IconType } from ".";

const EnquiryIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-none";
  const stroke = props.stroke ?? "stroke-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      viewBox="0 0 26 26"
      width={25}
      height={25}
      className={`${props.size}`}
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <g id="Interface-Essential__x2F__Select__x2F__cursor-question">
        <g id="Group_646">
          <g id="cursor-question">
            <path
              id="Oval_317"
              d="M10.75 24.25a9 9 0 1 0-.001-18.001 9 9 0 0 0 .001 18.001Z"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_2758"
              d="M24.25 1.75h-7.5l7.5 7.5v-7.5h0Z"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_2759"
              d="M10.75 19.75a.38.38 0 1 0 0 .76.38.38 0 0 0 0-.76h0"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_2760"
              d="M7.75 12.25a2.998 2.998 0 0 1 5.92-.67c.34 1.49-.49 2.99-1.92 3.5-.6.21-1 .78-1 1.41v.63"
              className={`cls-1 ${fill} ${stroke}`}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EnquiryIcon;
